// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".farewell-text[data-v-06b44824]{margin-bottom:30px}.farewell-text[data-v-06b44824],.text-field[data-v-06b44824]{color:#606266;font-weight:500;font-size:16px}.text-field[data-v-06b44824]{margin-top:10px;margin-bottom:10px}.text-capitalize[data-v-06b44824]{text-transform:capitalize}.star-center[data-v-06b44824]{text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
